export enum AttachmentType {
  PRAKTIKUMSNACHWEIS = "PRAKTIKUMSNACHWEIS",
  SONDERFALLNACHWEIS = "SONDERFALLNACHWEIS",
  BEZUGSNACHWEIS = "BEZUGSNACHWEIS",
  OTHER = "OTHER"
}
